import CustomButton from "../../../../../../components/stateless/customButton/CustomButton";
import { RecordStatuses } from "../../../../../../utilities/enums/RecordStatuses";
import { useChapterHistoryTableController } from "./ChapterHistoryTableController";

const ChapterHistoryTable = (props: any) => {
  const {
    selectedChapter,
  } = props;

  const {
    historyItems,
    downloadPdf
  } = useChapterHistoryTableController(selectedChapter);

  return (
    <div style={{margin:'10px', padding:'5px', display:'flex', flexDirection:'column'}}>
      {historyItems.map((item, index) => (
        <div key={`history-item-${index}`} className='k-card' style={{display:'flex', flexDirection:'row', width:'100%', margin:'5px', padding:'5px', alignItems:'center'}}>
          <div style={{display:'flex', marginRight:'20px'}}>
            <div style={{display: 'flex', marginRight:'10px'}}>
              {item.oldChapterNumber ?? selectedChapter.chapterNumber}{item.oldChapterName ? ": ".concat(item.oldChapterName) : ""}
            </div>
            { item.effectiveFrom && item.effectiveTo && (
              <div style={{display: 'flex', opacity:'0.8', fontStyle:'italic'}}>
                Effective Dates: {new Date(item.effectiveFrom).toDateString()} - {new Date(item.effectiveTo).toDateString()}
              </div>
            )}
            { item.effectiveFrom && !item.effectiveTo && (
              <div style={{display: 'flex', opacity:'0.8', fontStyle:'italic'}}>
                Effective Dates: {new Date(item.effectiveFrom).toDateString()} - current
              </div>
            )}
          </div>
          <div style={{display: 'flex', marginLeft:'auto', alignItems:'center'}}>
            { item.recordStatusId && (
              <div style={{display:'flex'}}>
                {index === 0 ? "New" :
                  historyItems[index - 1].recordStatusId === RecordStatuses.New ? "New" :
                  historyItems[index - 1].recordStatusId === RecordStatuses.Amended ? "Amended" :
                  historyItems[index - 1].recordStatusId === RecordStatuses.Repealed ? "Repealed" :
                  historyItems[index - 1].recordStatusId === RecordStatuses.Draft ? "Draft" : null}
              </div>
            )}
            { item.pdfContainerName && item.pdfBlobName && (
              <div style={{marginLeft:'5px', display:'flex'}}>
                <CustomButton onClick={() => {downloadPdf(item.pdfContainerName, item.pdfBlobName)}} themeColor='success' size='small' icon='pdf' />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChapterHistoryTable;